import React from "react";
import { injectIntl } from "react-intl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Badge from "@app/components/Badge/Badge";
import Button from "@app/components/CustomButtons/Button";

import sectionBlogInfoStyle from "@app/assets/jss/material-kit-pro-react/views/blogPostSections/sectionBlogInfoStyle";

function SectionBlogInfo({ ...props }) {
  const { classes } = props;

  const post = props.intl.formatMessage({ id: "post" });
  const share = props.intl.formatMessage({ id: "share" });
  const tweet = props.intl.formatMessage({ id: "tweet" });

  const url = "https://localpro.ie" + props.path;
  const encodedURL = encodeURI(url);

  const redditURL = "https://www.reddit.com/submit?url=" + encodedURL + "&title=" + props.title.replace(/ /g,"+");
  const tweetURL = "https://twitter.com/intent/tweet?url=" + encodedURL;
  const fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + encodedURL;
  const linkedInURL = "https://www.linkedin.com/shareArticle?mini=true&url=" + encodedURL + "&title=" + props.title.replace(/ /g,"+") + "&summary=&source=";

  const shareLinks = (
    <GridItem xs={12} sm={6} md={6}>
      <Button color="facebook" round className={classes.buttons}
        href={fbURL}
        target="_blank" rel="noopener">
        <i className="fab fa-facebook-square" />{share}
      </Button>
      <Button color="reddit" round className={classes.buttons}
        href={redditURL}
        target="_blank" rel="noopener">
        <i className="fab fa-reddit" />{post}
      </Button>
      <Button color="twitter" round className={classes.buttons}
        href={tweetURL}
        target="_blank" rel="noopener">
        <i className="fab fa-twitter" />{tweet}
      </Button>
      <Button color="linkedin" round className={classes.buttons}
        href={linkedInURL}
        target="_blank" rel="noopener">
        <i className="fab fa-linkedin" />{share}
      </Button>
    </GridItem>
  )
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <div className={classes.blogTags}>
                {props.tag1 ? <Badge color="success">{props.tag1}</Badge> : ''}
                {props.tag2 ? <Badge color="success">{props.tag2}</Badge> : ''}
                {props.tag3 ? <Badge color="success">{props.tag3}</Badge> : ''}
                {props.tag4 ? <Badge color="success">{props.tag4}</Badge> : ''}
                {props.tag5 ? <Badge color="success">{props.tag5}</Badge> : ''}
              </div>
            </GridItem>
            {shareLinks}
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default injectIntl(withStyles(sectionBlogInfoStyle)(SectionBlogInfo));
